import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';

import { enums } from '..';

type ResourceType = enums.RESOURCES_TYPES_ENUM.BASKET;

export const uploadAssetImage =
  (config: ApiConfig) =>
  (formData: FormData): Promise<any> => {
    return fetchWrapper(
      `${config.endpoint}assets/asset-image`,
      {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': undefined,
        },
      },
      config
    );
  };

export const fetchAssetImageUrl =
  (config: ApiConfig) =>
  async (resourceType: ResourceType, resourceId: number): Promise<string> => {
    const res = await fetchWrapper<{ url: string }>(
      `${config.endpoint}assets/asset-image/${resourceType}/${resourceId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': undefined,
        },
      },
      config
    );

    return res.url;
  };

export const deleteAssetImage =
  (config: ApiConfig) =>
  (resourceType: ResourceType, resourceId: number): Promise<any> => {
    return fetchWrapper(
      `${config.endpoint}assets/asset-image/${resourceType}/${resourceId}`,
      {
        method: 'DELETE',
      },
      config
    );
  };
